import { render, staticRenderFns } from "./TimetablePage.vue?vue&type=template&id=3e47acb3&"
import script from "./TimetablePage.vue?vue&type=script&lang=ts&"
export * from "./TimetablePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports